import React from 'react';
import {useField, useFormikContext} from 'formik';

import {Row} from '../layout';
import ErrorMessage from './ErrorMessage';
import Icon from '../icon';
import {Icons} from '../../util/icons';
import colors from '../../util/colors';
import './styles.scss';
import AppCheckboxInput from '../input/app-checkbox-input/AppCheckboxInput';

interface AppFormCheckboxFieldProps extends React.HTMLProps<HTMLInputElement> {
  label: any;
  labelClass?: string;
  name: string;
  showErrorMessage?: boolean;
  onChange?: any;
  handleFormikContext?: any;
  showIcon?: boolean;
  className?: string;
  purposeId?: string;
  value?: any;
  defaultColor?: boolean;
}

function AppFormCheckboxField({
  label,
  labelClass,
  name,
  handleFormikContext,
  onChange,
  className,
  showErrorMessage = false,
  showIcon = false,
  purposeId,
  value,
  defaultColor,
}: AppFormCheckboxFieldProps) {
  const formik = useFormikContext();
  const {setFieldTouched, errors, touched, setFieldValue} = formik;
  const error = (errors as any)[name];
  const visible = (touched as any)[name];

  const [field] = useField(name);
  if (!!handleFormikContext) {
    handleFormikContext(formik);
  }

  return (
    <Row>
      <AppCheckboxInput
        purposeId={purposeId}
        className={className}
        value={value ? value : field.value}
        label={label}
        labelClass={labelClass}
        name={name}
        checked={value ? value : field.value}
        onChange={(value) => {
          onChange ? onChange(value) : setFieldValue(name, value);
        }}
        onBlur={() => setFieldTouched(name)}
        // {...rest}
      />
      {error && visible && showIcon && (
        <Icon
          className="app-form-field-error-icon app-form-field-error-date"
          name={Icons.ALERT_PROBLEM}
          color={colors.alertRed}
          width="24"
          height="24"
        />
      )}
      {showErrorMessage && <ErrorMessage error={error} visible={visible} />}
    </Row>
  );
}

export default AppFormCheckboxField;
